module.exports = __webpack_public_path__ + "media/images/employees/sara-e6fbb119c0b61ecc3789d1ea888bb330.png";